import axiosInstance from "../../api/axiosConfig";

export const getOrder = (orderId: string) => {
  return axiosInstance.get(`/orders/${orderId}`);
};
